export default __webpack_public_path__ + "static/media/gum3.e79ab91a.png";